var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.passUrl}},[_c('img',{staticClass:"icon-pdf",attrs:{"src":_vm.iconPath('v_print.svg'),"alt":""}}),_vm._v(" Распечатать пропуск ")])}
var staticRenderFns = []

export { render, staticRenderFns }